<template>
  
    
      <v-app>
        <h1>Email Editor</h1>
        <v-row class='ma-5'>
          <v-col  cols='4'>
   <v-select
         @change='loadDesign'
         v-model='selectedTemplateItem'
          :items="templateList"
          label="Load Template"
          outlined
          item-text="name"
          item-value="body"
        ></v-select>
          </v-col>
          <v-col cols='2'>
            <v-btn class='mr-5'
          large
          @click='newTemplate'
        >
          New
        </v-btn>
          <v-btn
          large
          @click='templateId ? saveDesign() : dialog = true'
        >
          Save
        </v-btn>
             <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">
        Name for this template: 
        </v-card-title>

        <v-card-text>
         <v-col
          cols="12"
        >
          <v-text-field
            v-model='templateName'
            label="Name"
          ></v-text-field>
        </v-col>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled='!templateName'
            @click="saveDesign"
          >
            Save Template
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
          </v-col>
          
        </v-row>
   
  

      
       
   

      <EmailEditor style='height : 1200px'
        :appearance="appearance"
        :min-height="minHeight"
        :locale="locale"
        :tools="tools"
        :options="options"
        ref="emailEditor"
        v-on:load="editorLoaded"
      />

   </v-app>

</template>

<script>
import { postReq} from '../helper/firestore'
  import { EmailEditor } from 'vue-email-editor'
  
  export default {
    name: 'app',
    components: {
      EmailEditor
    },
    data() {    
      return {
        selectedTemplateItem : null,
        emptyDesign : null,
        templateName : "",
        templateId: null,
        templateBody : null,
        dialog : false,
        templateList : [],
        design : null,
        JSONDesign : "",
        minHeight: "1000px",
        locale: "en",
        tools: {
          // disable image tool
          image: {
            enabled: true
          }
        },
        options: {},
        appearance: {
          theme: 'light',
          panels: {
            tools: {
              dock: 'right'
            }
          }
        } 
      }
    },
    mounted(){
        postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/getEmailTemplate',{},(res)=>{
            this.templateList = res.data;
        })
    },
    methods: {
      newTemplate(){
          this.selectedTemplateItem = undefined;
          this.templateName = undefined;
           this.$refs.emailEditor.editor.loadBlank({
  backgroundColor: '#e7e7e7'
});

      },
      editorLoaded() {
      },
      loadDesign(val){
        let selectedTemplate = this.templateList.find(t => t.body === val);
        this.templateName = selectedTemplate.name 
      this.templateId = selectedTemplate.id
      this.templateBody = selectedTemplate.body
   this.$refs.emailEditor.editor.loadDesign(JSON.parse(JSON.parse((val))));
      },
      saveDesign() {
        this.$refs.emailEditor.editor.saveDesign(
          (design) => {
            this.design = design;
            this.JSONDesign = JSON.stringify((JSON.stringify(design)));
            let payload = this.templateId ? {
          emailTemplate : this.templateBody ,name: this.templateName, id: this.templateId
        } : {
          emailTemplate : this.JSONDesign,name: this.templateName
        }
        postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/saveEmailTemplate',payload,(res)=>{
            console.log(res.data);
            this.dialog = false
             postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/getEmailTemplate',{},(res)=>{
            this.templateList = res.data;
        })
        })
          }
        )
      },
      exportHtml() {
        this.$refs.emailEditor.editor.exportHtml(
          (data) => {
            console.log('exportHtml', data);
          }
        )
      }
    }
  }
</script>